import React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsx mdx */

import DefaultLayout from "/zeit/55195781/node_modules/gatsby-theme-carbon/src/templates/Default.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Caption = makeShortcode("Caption");
const Row = makeShortcode("Row");
const Column = makeShortcode("Column");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <h2>{`Color`}</h2>
    <p>{`Refer to the `}<a parentName="p" {...{
        "href": "/components/button/style"
      }}>{`button`}</a>{` for primary and secondary button styling in the transactional modal.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Class`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Color token`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-container`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`background-color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$ui-01`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-header__label`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`text color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$text-02`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-header__heading`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`text color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$text-01`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-content`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`text color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$text-01`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-close__icon`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`fill`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$icon-01`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-close:hover`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`background-color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$hover-ui`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`Overlay`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`color`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$overlay-01`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h2>{`Typography`}</h2>
    <p>{`Modal titles and labels should be set in sentence case. Keep all titles and labels concise and to the point. Modal labels are optional.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Class`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Font-size (px/rem)`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Font-weight`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Type token`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-header__label`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`12 / 0.75`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Regular / 400`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$label-01`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-header__heading`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`20 / 1.25`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Regular / 400`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$heading-03`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-content`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`14 / 0.875`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`Regular / 400`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$body-long-01`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <h2>{`Structure`}</h2>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Class`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Property`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`px / rem`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Spacing token`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-close`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`height, width`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`48 x 48`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`–`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-close__icon`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`height, width`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16 x 16`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`–`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-header__label`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`margin-bottom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`4 / 0.25`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$spacing-02`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-header`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`padding top, padding left`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16 / 1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$spacing-05`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-header`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`margin-bottom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16 / 1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$spacing-05`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-content`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`padding-left`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16 / 1`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$spacing-05`}</inlineCode></td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-content`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`padding-right`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`20%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`–`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`.bx--modal-content`}</inlineCode></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`margin-bottom`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`48 / 3`}</td>
          <td parentName="tr" {...{
            "align": null
          }}><inlineCode parentName="td">{`$spacing-09`}</inlineCode></td>
        </tr>
      </tbody>
    </table>
    <div className="image--fixed">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "48.641304347826086%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAKCAYAAAC0VX7mAAAACXBIWXMAAAsSAAALEgHS3X78AAABxElEQVQoz52ST2/TMBjG26Q3xA3xeTjBBQnxNeCOxKeY0HKhcEEI7cKfCxIIxB+1FdBO4sBQl6QrI6ROGsdO7DgJWVLtxfaWahVwgFf65XFsP0/8Ku4AQEfVZIm7Dk17bpKYhyI3vbI0vaKQlJvI+TnjPR/APAAw9kd72u8K0VlXG/q/5Yynv4c9OpxfGZD43gDj7Q9JYo05tz4yZo0IsUaUSlql1iCh2yMU9t/uOVuvAM4p/xuMTwLjZWrqr/jRLcIqCGMMqRAaXpbwp1qdahjhyq+Ki8ofMNbVgfY+0YFzl934Nk0hioIKLVCNFos6DIKaElJTSusY4zqRWpZlzYU4KosCRJEjL44v6IO1gTP/hw5c4Ojmd88Dezo9ch2nmbluo9Sx7caVyHn5bjc4ihrGef1TBvIsQz6lm4Hy5IbS5wjd/rJawZgxmGQZjBWcw26ew65sX+lEqlr7XFXgSuOnNM1fY6xbHlK6DtSDrZl77RkhOy84vyvpK15mWb8dn+UpIfefYPzwMcZ3HgTovPLvLMPT33z50omanZ58dv/htnT/fu2uX10vfD0+Nt4xZgyFMAZZtsFQ8p5zQ3Wl9racDf0F6A26lCYewHcAAAAASUVORK5CYII=')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Structure and spacing measurements for a passive modal",
          "title": "Structure and spacing measurements for a passive modal",
          "src": "/static/1b9b2289c99b0d2b06b889cf4df28c29/3cbba/modal-style-1.png",
          "srcSet": ["/static/1b9b2289c99b0d2b06b889cf4df28c29/7fc1e/modal-style-1.png 288w", "/static/1b9b2289c99b0d2b06b889cf4df28c29/a5df1/modal-style-1.png 576w", "/static/1b9b2289c99b0d2b06b889cf4df28c29/3cbba/modal-style-1.png 1152w", "/static/1b9b2289c99b0d2b06b889cf4df28c29/392b1/modal-style-1.png 1472w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </div>
    <Caption mdxType="Caption">
  Structure and spacing measurements for a passive modal | px / rem
    </Caption>
    <div className="image--fixed">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "69.02173913043478%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAAOCAYAAAAvxDzwAAAACXBIWXMAAAsSAAALEgHS3X78AAADHElEQVQ4y62SW2gTWRjHz2SUVR/UxfogPuyD4KP2ojTVNpaA+JqK2KplcXUvaPXZYqnosojtesE3k6qgILuIeGm7D0W7XlihsKVsL2kSU9M0mc5kpslcM0kmM2c+z5zIIvjaA7/5/8/l+3O+wyA0eBUBAPKGAcAQ7/tX1XxjPM+OiyL7UhAob/J59m2hwL4jvCZ+vJBneXL2Ocf5vNpHHxJoWODRqozw7OwXM3LDibLOeLZ3aqI5kor9+JQXOkYlMTQiiqHhXC70QhBCo5JE538RHV1Z6XjEcZ13ksnTdxdTQa/2XnQO3U2nibv2G1LkyhpvcXJRvJyRyhDjMpDgeUjmchDnOOqlcgkU24aCZRFfBqFUAvJEEJfE917tPzMzzIIs1y65kJJo4NKifGH5owbL3FI1u7SE+WwWZ9NpvExU4DjMZTI4L0m4bJq4aBhVwBgUTRv3aiumyciaVms5Iwo0MLOS6+VyHMzPz1djsZhL1J2LRt14PE7xfCKRcDMc56q67mDXBUlV//ZqiyWDERWVuONHUU6WaSBfKPTaDoaSadpm0XQNw4BisfgVqqaBbhgO6RhkU6OB+eUSo5TVWss5WaGBoqz2eocMQ7dJmFshb2WRN7MqFaI2VCyHYlU9tWlgKmnSQGKZqfc6cTcGUBmA9RbH9JXLSbIzbTv2tOO4Mxj/z7Stu1FLcaNVxZ2r4aTAgrfpwudAiXk1qRB363f0+MECDbx5P9o/8MdT6BsKW33hiNMXiTgXw2HnUnjI+fXPLD7zrIJ/eVLEP9eonh3G8NMz/bVXe/s6oEPDC7WW9zcFacutDcH+YKAd9jY2QNPu3dBUT7R+FzTW74HtnSnYcApgzQmAtd2fOUk4jifQyI51vh8e+mppV/pRc1sj/bGbAw07/ftaOtsCB0KB9vbDlAOBjtbgwcN1p+a6Np11urb2FI9tOad21/WYXXU9pe4t5/WDyEIMIEDrb/1HUu5HaG7j3l0MWq3h9/uptrS0MATWg6yxfs/7m4m2stuOfGQ3fg/styeA/a4NmM1EN3dTfORyqI98vhmMok/5GEc7bDCG/AAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Structure and spacing measurements for a transactional modal",
          "title": "Structure and spacing measurements for a transactional modal",
          "src": "/static/d77fab1884a72aa473a6cde561235f0d/3cbba/modal-style-2.png",
          "srcSet": ["/static/d77fab1884a72aa473a6cde561235f0d/7fc1e/modal-style-2.png 288w", "/static/d77fab1884a72aa473a6cde561235f0d/a5df1/modal-style-2.png 576w", "/static/d77fab1884a72aa473a6cde561235f0d/3cbba/modal-style-2.png 1152w", "/static/d77fab1884a72aa473a6cde561235f0d/392b1/modal-style-2.png 1472w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </div>
    <Caption mdxType="Caption">
  Structure and spacing measurements for a transactional modal | px / rem
    </Caption>
    <h3>{`Margin-right`}</h3>
    <p>{`Modals that are 36% width and larger have a `}<inlineCode parentName="p">{`margin-right: 20%`}</inlineCode>{` (margin percentage is based off the width of the modal window). If the modal is smaller than 36% then it has a fixed `}<inlineCode parentName="p">{`margin-right: 16px/1rem`}</inlineCode>{`. Body copy, including titles, in a modal alway follows the 20% margin-right rule. However, inputs and other components may still expand to the full width of a modal window.`}</p>
    <div className="image--fixed">
      <span {...{
        "className": "gatsby-resp-image-wrapper",
        "style": {
          "position": "relative",
          "display": "block",
          "marginLeft": "auto",
          "marginRight": "auto",
          "maxWidth": "1152px"
        }
      }}>{`
      `}<span parentName="span" {...{
          "className": "gatsby-resp-image-background-image",
          "style": {
            "paddingBottom": "86.97916666666667%",
            "position": "relative",
            "bottom": "0",
            "left": "0",
            "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAARCAYAAADdRIy+AAAACXBIWXMAAAsSAAALEgHS3X78AAACxUlEQVQ4y51TS2sTURS+U5HiQvAX1ICgRcEHgi31NygKxY0LN+4E163u+wcC4kJwIa0gfUALTkhSi1IqPqptxbxIk8ljJnfuTGYy7zQ3yfXcaVMroQ888M0Z5pz78Z2530EIIrq8zBOakST0ZHISPZuYQFNTU2h8fBxFo1FEKUWubSNxbQ29SKXC3kVZRkfGdKGAThovs9mjGxK1msDzLMbDKVmOkVpNxKoqVioVkRAiep4n+o4by+v60luML/BeUdOEwwkxHuB5jqi3S5bFbNNkZqPBDMNgruuyTqfDeCi+z2YwvhkS6trAoYRxRQmL84SMbBSLNJ/N0mwu18rlcpQjnU63SoVCO4OxO2ea1/cUHk4Yk+Vdhao6CoQMDrN8Ps+2t7dDFCWJ6YSwdE2h86Z541jCFV0Pi7OqeqtiWW4Ac9qO4zo9uK7TCgKv4jjGNMbXjh356ceVMD9Mxs+93vw5iuv1y03fvwS8HMM7fnBxU5KuvvqxPvJ8/dtZ3vsOflPSNAWxXg/P9vJ+fGcM/W/0kX3xvDAvaNrgDmMRdgBwwxHLsiKe40Rgdp7PK7Y9lDDNoWX4DmRn+kjBh/uX8rtaZXKl0lUJ6Wqa1gXrdMGHXRg9hA+QLaubaDToKqXsva7f3SM81Wcb8OHor1KJleFWS+UyK8KNK4rCbNtmoDL0ZuB5rOY4DBS2P3c7DIhCwthBwphc7SkcWc/n29l0ug0+pFnwI3iQplIpmslk6ObWFi2BT8uGQYGwudpqccI7fQo/EBISLhAyJsNmgG2YwwFK+Kb4sCEwNvMg85oK75+CgG3ATwZl90NRhvGXUFRxuJdvqtUrkmWt7ARBAkjigF7uIQG1uOI4SdGoJ0HV10VNG+Nnl/4x+oN7u/nxo9PwHDyhW7iIUBU7ynK8SJtNATZFAJsIMPY+PNcVDMsSoIcD9XCQ9A/evX1GNIrwDAAAAABJRU5ErkJggg==')",
            "backgroundSize": "cover",
            "display": "block"
          }
        }}></span>{`
  `}<img parentName="span" {...{
          "className": "gatsby-resp-image-image",
          "alt": "Margin-right for modals less than 36% and greater than 36%",
          "title": "Margin-right for modals less than 36% and greater than 36%",
          "src": "/static/8ebb628a49954a95d31d40eab35bd58c/3cbba/modal-style-3.png",
          "srcSet": ["/static/8ebb628a49954a95d31d40eab35bd58c/7fc1e/modal-style-3.png 288w", "/static/8ebb628a49954a95d31d40eab35bd58c/a5df1/modal-style-3.png 576w", "/static/8ebb628a49954a95d31d40eab35bd58c/3cbba/modal-style-3.png 1152w", "/static/8ebb628a49954a95d31d40eab35bd58c/192f4/modal-style-3.png 1536w"],
          "sizes": "(max-width: 1152px) 100vw, 1152px",
          "style": {
            "width": "100%",
            "height": "100%",
            "margin": "0",
            "verticalAlign": "middle",
            "position": "absolute",
            "top": "0",
            "left": "0"
          },
          "loading": "lazy"
        }}></img>{`
    `}</span>
    </div>
    <Caption mdxType="Caption">
  Margin-right for modals less than 36% (left) and greater than 36% (right).
    </Caption>
    {
      /*
      ### Buttons widths
      | Number of buttons    | Percentage of modal     | Positioning    |
      | -------------------- | ----------------------- | -------------- | 
      | 1                    | 50%                     | Flush right    |
      | 2                    | 50% each                | Full bleed     |
      | 3                    | 25% each                | Flush right    |
      */
    }
    <h2>{`Sizes`}</h2>
    <p>{`There are four modal sizes: `}<strong parentName="p">{`xs, small, default, large`}</strong>{`. Each modal size has a responsive width that changes based on the browser size. As the browser decreases, the modal width percentage increases thus maintaining a proper ratio between the modal and browser. Modal widths are defined as percentages of the browser but will still align to columns on the 2x grid.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "62.90760869565217%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAACMklEQVQ4y41TW4vaYBDd/1wKXcF7tUZXBas1sfESTbRSFlu1ilvfCkWFQqHbeqk1brJ9sPpQUKuCeppJMO4u28vAQPLlzJmTOfOdQIv9fq/nIQ7vN/M+3F0sxYmqqhBFEYVCAdlsFhkhazwLAlqtllm02WxQLpd1bC6XQzojaHgRkiShVCphtVoZhL1eDx6PB16vFxeNBr58+oBwKASHw4Fa7Y2phApYloXT6cTbZhOK/BXv3zXhcrkQi8WwWCwMwsFgAH8ggFAwCD4lgH0lIxzh4HviQUNrcJMwmUyC8fuRTnJIvf6MyPkVAowHHJfAcrk0CPv9Pnw+H4LBM9jsdjy0BhA4C+mq6/X6LcJEIgGGYWC3WfHg9DEsrqfwMz7E43EsDoQkdTQaQZZlKIqCa0XGeCzjm3Y2nU7NGe52O9C8CasoKq7VMdSrEUZanarVbbdbgxD/CCKivOvun7C6wuFwCJplt9vVk8ZA75PJxFRICsbjMchEygOWks5NhfSRHI1EIvpK5AsvkE5nYLPZUK1Wze7UmNykpPXKZnPIiRJ4zahn2gxNU0id2+1Gu902i6eT78YaXVyYZ/P5XG84m81u/eZq+RP5vHRcG1JIhIzmFuMP4BF7CQv7EU67VVN43ENSEI1G9RULBxm4YzVYhB845S4RjfP4tVwcb0qxWNS7J1Mp8JkiMuK53rXT6ZiE6/UalUoFPM9r+8jjeVoCJ5TApV+iojXebNb/5/J99/dv2N9fTYPXgnTJfgAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Modal sizes",
            "title": "Modal sizes",
            "src": "/static/8624364fd9e1199bf1cb42140170ef54/3cbba/modal-usage-sizes.png",
            "srcSet": ["/static/8624364fd9e1199bf1cb42140170ef54/7fc1e/modal-usage-sizes.png 288w", "/static/8624364fd9e1199bf1cb42140170ef54/a5df1/modal-usage-sizes.png 576w", "/static/8624364fd9e1199bf1cb42140170ef54/3cbba/modal-usage-sizes.png 1152w", "/static/8624364fd9e1199bf1cb42140170ef54/392b1/modal-usage-sizes.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>
    <h3>{`XS`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Breakpoint`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Percentage width`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Column span`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Margin-right`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`1584`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`24%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`4 of 16`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16px / 1rem`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`1312`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`24%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`4 of 16`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16px / 1rem`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`1056`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`32%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`5 of 16`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16px / 1rem`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`672`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`48%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`4 of 8`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16px / 1rem`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`320`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`100%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`4 of 4`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16px / 1rem`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Small`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Breakpoint`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Percentage width`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Column span`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Margin-right`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`1584`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`36%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`6 of 16`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`20%`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`1312`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`36%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`6 of 16`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`20%`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`1056`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`42%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`7 of 16`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16px / 1rem`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`672`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`60%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`5 of 8`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16px / 1rem`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`320`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`100%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`4 of 4`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16px / 1rem`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Default`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Breakpoint`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Percentage width`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Column span`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Margin-right`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`1584`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`48%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`8 of 16`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`20%`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`1312`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`48%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`8 of 16`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`20%`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`1056`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`60%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`10 of 16`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`20%`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`672`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`84%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`7 of 8`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`20%`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`320`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`100%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`4 of 4`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16px / 1rem`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Large`}</h3>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Breakpoint`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Percentage width`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Column span`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Margin-right`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`1584`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`72%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`12 of 16`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`20%`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`1312`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`72%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`12 of 16`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`20%`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`1056`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`84%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`14 of 16`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`20%`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`672`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`96%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`8 of 8`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`20%`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}>{`320`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`100%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`4 of 4`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`16px / 1rem`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Max sizes`}</h3>
    <p>{`Each modal size has a max height and width in order to maintain a proper window ratio.`}</p>
    <table>
      <thead parentName="table">
        <tr parentName="thead">
          <th parentName="tr" {...{
            "align": null
          }}>{`Modal size`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Max-height`}</th>
          <th parentName="tr" {...{
            "align": null
          }}>{`Max-width`}</th>
        </tr>
      </thead>
      <tbody parentName="table">
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`XS`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`48%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`420px`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Small`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`72%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`576px`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Default`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`84%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`768px`}</td>
        </tr>
        <tr parentName="tbody">
          <td parentName="tr" {...{
            "align": null
          }}><strong parentName="td">{`Large`}</strong></td>
          <td parentName="tr" {...{
            "align": null
          }}>{`96%`}</td>
          <td parentName="tr" {...{
            "align": null
          }}>{`–`}</td>
        </tr>
      </tbody>
    </table>
    <h3>{`Mobile`}</h3>
    <p>{`On mobile devices, at the smaller break points the max-height does not apply. The height may either be 100% of the screen or maintain the height defined by the content while sticking to the bottom of the mobile screen.`}</p>
    <Row mdxType="Row">
      <Column colLg={8} mdxType="Column">
        <span {...{
          "className": "gatsby-resp-image-wrapper",
          "style": {
            "position": "relative",
            "display": "block",
            "marginLeft": "auto",
            "marginRight": "auto",
            "maxWidth": "1152px"
          }
        }}>{`
      `}<span parentName="span" {...{
            "className": "gatsby-resp-image-background-image",
            "style": {
              "paddingBottom": "64.53804347826086%",
              "position": "relative",
              "bottom": "0",
              "left": "0",
              "backgroundImage": "url('data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABQAAAANCAYAAACpUE5eAAAACXBIWXMAAAsSAAALEgHS3X78AAAC4ElEQVQ4y42TX0hTURzHr1zcYDqz/XFtE1lEQfSkCd6Cymmbg2GKL8Zc0jJWthejIiv2Is5/CP6d6EsQyJjMXDbIIfggwhw9zITQZ1ETyv3RbXe73q1f5xzLpMC68OX8zv3+7uee8zvnR1H/8ezs7Ag2NzdF/0jL+fOFAqkV6dExKbGxsLAgDIVCeTgWi8WFQqHwMdJzpGcCgeAVGi9iLzc3N4fS6/U0nlRVVTVZLBZobm4mamlpgdra2jvYc7vdIgQV47isrOwKyoXq6mrQarVgMBiAYRg79nQ6HY2TCXBiYsK0t7cH8XicSyQSaZZlwefzNWFvdXVVFAwGCdBkMlX09PTAyMgINzg4mB4bGwObzdaOvaGhIZqanJwkwNHRUVM4HAakTCQS4aPRKHg8HgJE2xUtLy8TYGNjI9PZ2Qn9/f3Zvr4+fnh4GKxW6wvs9fb20pTL5SJA9CcTWhkkk8lMKpXi0QjT09PmX8BAIECADQ0NjN1uB4fDke3o6OARFFCpCBDNfwOdTucRkGUxkAXPMSASAba1tTFerxfm5+ezH+bm+KWlJejq6ibAOb//byASArJkhWjLR8C1tTUCRLVjtra2YH9/Pxve/cYDfAff+1kCZJMJmpqamiLA8fFxUzqdBo7jMgcHHM9xafDOzJAaflpZOQIODAxUbGxsQCwWy3zdjfJphHw7844cSiQWpymj0UgfHnlNU+tDKzywPeFuOcIpYzcLV++6yQrfzIZEi4uLBHj9hpYxm81guXefr2n/zN10AJSbXS+xp7WHaUomkxGgTCa/LZNJQa5QQkHJNcgrqYQCVamJXAfna5Hf78/HcVGRolwqRXlyORQWl0K+moFTyktPsZevvExTKpWKtIlKpTytVKnqitXK+rNFOfUaKVV3TkFJsPcxGBCur6+T1rtw/rwQfVOpVqv1GoVQp5FRBo2ckmNPI//ZcxKJ5MQm3d7+IkB1O7GXz4gPxx9tsHgNPBsLFQAAAABJRU5ErkJggg==')",
              "backgroundSize": "cover",
              "display": "block"
            }
          }}></span>{`
  `}<img parentName="span" {...{
            "className": "gatsby-resp-image-image",
            "alt": "Modal sizes",
            "title": "Modal sizes",
            "src": "/static/68be41ffcfb0e54c5aeae79bd9544be1/3cbba/modal-style-4.png",
            "srcSet": ["/static/68be41ffcfb0e54c5aeae79bd9544be1/7fc1e/modal-style-4.png 288w", "/static/68be41ffcfb0e54c5aeae79bd9544be1/a5df1/modal-style-4.png 576w", "/static/68be41ffcfb0e54c5aeae79bd9544be1/3cbba/modal-style-4.png 1152w", "/static/68be41ffcfb0e54c5aeae79bd9544be1/392b1/modal-style-4.png 1472w"],
            "sizes": "(max-width: 1152px) 100vw, 1152px",
            "style": {
              "width": "100%",
              "height": "100%",
              "margin": "0",
              "verticalAlign": "middle",
              "position": "absolute",
              "top": "0",
              "left": "0"
            },
            "loading": "lazy"
          }}></img>{`
    `}</span>
      </Column>
    </Row>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      